<template>
  <div class="over-page" @click.self="close">
    <main>
      <div class="frame mid">
        <div class="modal-content-wrapper">
          <header class="page-title">
            <h3>Nova Forma de Pagamento</h3>
            <router-link target="_blank" :to="{name:'forma-pagamento'}" class="btn btn-secondary">Ver todos</router-link>
          </header>

          <div class="modal-body">
            <div class="form-group">
              <input-control
                required
                id="nome"
                label="Nome"
                placeholder="Pagamento à vista"
                v-model="form.nome"
              />
            </div>

            <div class="d-flex align-center mb-4">
              <switch-control v-model:checked="hasEntrada" labelOn="Forma de pagamento com entrada" labelOff="Forma de pagamento sem entrada" invert></switch-control>
            </div>

            <div class="tabs-panel">
              <nav class="tabs-navs">
                <a
                  href="#"
                  @click.prevent="activeTab = 'entrada'"
                  :class="['tabs-nav', { active: activeTab === 'entrada' }]"
                  v-if="hasEntrada"
                >
                  <span>Entrada</span>
                </a>

                <a
                  href="#"
                  @click.prevent="activeTab = 'parcelas'"
                  :class="['tabs-nav', { active: activeTab === 'parcelas' }]"
                >
                  <span>Parcelas</span>
                </a>

                <a
                  href="#"
                  @click.prevent="activeTab = 'descontos'"
                  :class="['tabs-nav', { active: activeTab === 'descontos' }]"
                >
                  <span>Descontos</span>
                </a>
              </nav>
              <div class="tabs-controller">
                <div v-if="activeTab === 'entrada' && hasEntrada">
                  <!-- Cartão -->
                  <section class="method-card">
                    <div class="method-header row">
                      <div class="col-md-4 form-group">
                        <input-control label="PAR Código" placeholder="Par Código" v-model="form.entrada.PARCodigo"/>
                      </div>
                    </div>
                  </section>

                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Cartão" labelOff="Cartão" v-model:checked="entradaCartaoAtivo" />
                    </div>

                    <div
                      v-if="form.entrada.cartao.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Percentual Mínimo"
                          placeholder="30%"
                          v-model="form.entrada.cartao.percentualMinimo"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Máximo Parcelas"
                          placeholder="3"
                          v-model="form.entrada.cartao.maximoParcelas"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.entrada.cartao.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.entrada.cartao.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>

                  <!-- Boleto -->
                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Boleto" labelOff="Boleto" v-model:checked="entradaBoletoAtivo" />
                    </div>

                    <div
                      v-if="form.entrada.boleto.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Percentual Mínimo"
                          placeholder="30%"
                          v-model="form.entrada.boleto.percentualMinimo"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Máximo Parcelas"
                          placeholder="3"
                          v-model="form.entrada.boleto.maximoParcelas"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.entrada.boleto.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.entrada.boleto.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>

                  <!-- Pix -->
                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Pix" labelOff="Pix" v-model:checked="entradaPixAtivo" />
                    </div>

                    <div
                      v-if="form.entrada.pix.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-4 form-group">
                        <input-control
                          label="Percentual Mínimo"
                          placeholder="30%"
                          v-model="form.entrada.pix.percentualMinimo"
                        />
                      </div>
                      <div class="col-md-4 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.entrada.pix.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-4 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.entrada.pix.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>
                </div>

                <div v-else-if="activeTab === 'parcelas'">
                  <section class="method-card">
                    <div class="method-header row">
                      <div class="col-md-4">
                        <input-control label="PAR Código" placeholder="Par Código" v-model="form.parcelas.PARCodigo"/>
                      </div>
                    </div>
                  </section>
                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Cartão" labelOff="Cartão" v-model:checked="parcelasCartaoAtivo" />
                    </div>

                    <div
                      v-if="form.parcelas.cartao.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Máximo Parcelas"
                          placeholder="3"
                          v-model="form.parcelas.cartao.maximoParcelas"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.parcelas.cartao.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.parcelas.cartao.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>

                  <!-- Boleto -->
                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Boleto" labelOff="Boleto" v-model:checked="parcelasBoletoAtivo" />
                    </div>
                    <div
                      v-if="form.parcelas.boleto.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Máximo Parcelas"
                          placeholder="3"
                          v-model="form.parcelas.boleto.maximoParcelas"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.parcelas.boleto.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.parcelas.boleto.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>

                  <!-- Pix -->
                  <section class="method-card">
                    <div class="method-header">
                      <switch-control labelOn="Pix" labelOff="Pix" v-model:checked="parcelasPixAtivo" />
                    </div>

                    <div
                      v-if="form.parcelas.pix.ativo"
                      class="row g-16 method-fields"
                    >
                      <div class="col-md-4 form-group">
                        <input-control
                          label="Competência Inicial"
                          placeholder="2025/01"
                          masking="competencia"
                          v-model="form.parcelas.pix.competenciaInicial"
                        />
                      </div>
                      <div class="col-md-4 form-group">
                        <input-control
                          label="Dia Vencimento"
                          placeholder="5"
                          v-model="form.parcelas.pix.diaVencimento"
                          type="number"
                        />
                      </div>
                    </div>
                  </section>
                </div>

                <div v-else>
                  <section>
                    <article class="method-card row g-16 descontos">
                      <div class="col-md-3 form-group">
                        <input-control label="Desconto Principal (%)" placeholder="20" v-model="form.descontoPrincipal"/>
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control label="Desconto Multa (%)" placeholder="10" v-model="form.descontoMulta"/>
                      </div>
                      <div class="col-md-3 form-group">
                        <input-control label="Desconto Juros (%)" placeholder="10" v-model="form.descontoJuros"/>
                      </div>
                    </article>
                  </section>
                </div>
              </div>
            </div>
          </div>
          <footer>
            <button class="btn btn-secondary" @click="close">Voltar</button>
            <button class="btn btn-primary" @click="salvar">Salvar</button>
          </footer>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import negociejaService from '@/services/negocieja.service.js'

export default {
  name: 'NovoPagamento',
  props: {
    formaParaEditar: {
      type: Object,
      default: null
    }
  },
  emits: ['fechar'],
  data() {
    return {
      activeTab: 'entrada',
      hasEntrada: false,
      form: {
        nome: '',
        descontoPrincipal: '',
        descontoMulta: '',
        descontoJuros: '',
        // PARCodigo: '',
        entrada: {
          PARCodigo: '',
          cartao: {
            ativo: false,
            percentualMinimo: '',
            maximoParcelas: '',
            competenciaInicial: '',
            diaVencimento: '',
          },
          boleto: {
            ativo: false,
            percentualMinimo: '',
            maximoParcelas: '',
            competenciaInicial: '',
            diaVencimento: '',
          },
          pix: {
            ativo: false,
            percentualMinimo: '',
            competenciaInicial: '',
            diaVencimento: '',
          }
        },
        parcelas: {
          PARCodigo: '',
          cartao: {
            ativo: false,
            maximoParcelas: '',
            competenciaInicial: '',
            diaVencimento: ''
          },
          boleto: {
            ativo: false,
            maximoParcelas: '',
            competenciaInicial: '',
            diaVencimento: ''
          },
          pix: {
            ativo: false,
            competenciaInicial: '',
            diaVencimento: ''
          }
        }
      }
    }
  },
  watch: {
  formaParaEditar: {
    immediate: true,
    handler(novoValor) {
      if (!novoValor || !novoValor.forma) return

      // Dados principais
      this.form.nome = novoValor.forma.nome
      this.form.descontoPrincipal = novoValor.forma.percentualCobrado
      this.form.descontoMulta = novoValor.forma.percentualDescontoMulta
      this.form.descontoJuros = novoValor.forma.percentualDescontoJuros

      // Ativa entrada
      this.hasEntrada = true

      // Entrada
      this.form.entrada.PARCodigo = novoValor.entrada.PARCodigoEntrada
      this.form.entrada.cartao = {
        ativo: novoValor.entrada.cartao,
        percentualMinimo: novoValor.entrada.percentualMinimoCartao,
        maximoParcelas: novoValor.entrada.maximoParcelasCartao,
        competenciaInicial: novoValor.entrada.competenciaInicialCartao,
        diaVencimento: novoValor.entrada.diaVencimentoCartao
      }
      this.form.entrada.boleto = {
        ativo: novoValor.entrada.boleto,
        percentualMinimo: novoValor.entrada.percentualMinimoBoleto,
        maximoParcelas: novoValor.entrada.maximoParcelasBoleto,
        competenciaInicial: novoValor.entrada.competenciaInicialBoleto,
        diaVencimento: novoValor.entrada.diaVencimentoBoleto
      }
      this.form.entrada.pix = {
        ativo: novoValor.entrada.pix,
        percentualMinimo: novoValor.entrada.percentualMinimoPix,
        competenciaInicial: novoValor.entrada.competenciaInicialPix,
        diaVencimento: novoValor.entrada.diaVencimentoPix
      }

      // Parcelas
      this.form.parcelas.PARCodigo = novoValor.parcelas.PARCodigoParcela
      this.form.parcelas.cartao = {
        ativo: novoValor.parcelas.cartao,
        maximoParcelas: novoValor.parcelas.maximoParcelasCartao,
        competenciaInicial: novoValor.parcelas.competenciaInicialCartao,
        diaVencimento: novoValor.parcelas.diaVencimentoCartao
      }
      this.form.parcelas.boleto = {
        ativo: novoValor.parcelas.boleto,
        maximoParcelas: novoValor.parcelas.maximoParcelasBoleto,
        competenciaInicial: novoValor.parcelas.competenciaInicialBoleto,
        diaVencimento: novoValor.parcelas.diaVencimentoBoleto
      }
      this.form.parcelas.pix = {
        ativo: novoValor.parcelas.pix,
        competenciaInicial: novoValor.parcelas.competenciaInicialPix,
        diaVencimento: novoValor.parcelas.diaVencimentoPix
      }
    }
  }
},
  computed: {
    // ENTRADA
    entradaCartaoAtivo: {
      get() {
        return this.form.entrada.cartao.ativo === 1
      },
      set(val) {
        this.form.entrada.cartao.ativo = val ? 1 : 0
      }
    },
    entradaBoletoAtivo: {
      get() {
        return this.form.entrada.boleto.ativo === 1
      },
      set(val) {
        this.form.entrada.boleto.ativo = val ? 1 : 0
      }
    },
    entradaPixAtivo: {
      get() {
        return this.form.entrada.pix.ativo === 1
      },
      set(val) {
        this.form.entrada.pix.ativo = val ? 1 : 0
      }
    },

    // PARCELAS
    parcelasCartaoAtivo: {
      get() {
        return this.form.parcelas.cartao.ativo === 1
      },
      set(val) {
        this.form.parcelas.cartao.ativo = val ? 1 : 0
      }
    },
    parcelasBoletoAtivo: {
      get() {
        return this.form.parcelas.boleto.ativo === 1
      },
      set(val) {
        this.form.parcelas.boleto.ativo = val ? 1 : 0
      }
    },
    parcelasPixAtivo: {
      get() {
        return this.form.parcelas.pix.ativo === 1
      },
      set(val) {
        this.form.parcelas.pix.ativo = val ? 1 : 0
      }
    }
  },
  methods: {
    close() {
      this.$emit('fechar')
    },
    abrirLista() {
      console.log('Abrir lista de formas de pagamento existentes')
    },
    salvar() {
      // const payload = {
      //   nome: this.form.nome,
      //   descontoPrincipal: this.form.descontoPrincipal,
      //   descontoMulta: this.form.descontoMulta,
      //   descontoJuros: this.form.descontoJuros,
      //   entrada: {
      //     PARCodigo: this.form.entrada.PARCodigo,
      //     cartao: {
      //       ativo: this.form.entrada.cartao.ativo ? 1 : 0,
      //       percentualMinimo: this.form.entrada.cartao.percentualMinimo,
      //       maximoParcelas: this.form.entrada.cartao.maximoParcelas,
      //       competenciaInicial: this.form.entrada.cartao.competenciaInicial,
      //       diaVencimento: this.form.entrada.cartao.diaVencimento
      //     },
      //     boleto: {
      //       ativo: this.form.entrada.boleto.ativo ? 1 : 0,
      //       percentualMinimo: this.form.entrada.boleto.percentualMinimo,
      //       maximoParcelas: this.form.entrada.boleto.maximoParcelas,
      //       competenciaInicial: this.form.entrada.boleto.competenciaInicial,
      //       diaVencimento: this.form.entrada.boleto.diaVencimento
      //     },
      //     pix: {
      //       ativo: this.form.entrada.pix.ativo ? 1 : 0,
      //       percentualMinimo: this.form.entrada.pix.percentualMinimo,
      //       competenciaInicial: this.form.entrada.pix.competenciaInicial,
      //       diaVencimento: this.form.entrada.pix.diaVencimento
      //     }
      //   }, 
      //   parcelas: {
      //     PARCodigo: this.form.parcelas.PARCodigo,
      //     cartao: {
      //       maximoParcelas: this.form.parcelas.cartao.maximoParcelas,
      //       competenciaInicial: this.form.parcelas.cartao.competenciaInicial,
      //       diaVencimento: this.form.parcelas.cartao.diaVencimento
      //     },
      //     boleto: {
      //       ativo: this.form.parcelas.boleto.ativo ? 1 : 0,
      //       maximoParcelas: this.form.parcelas.boleto.maximoParcelas,
      //       competenciaInicial: this.form.parcelas.boleto.competenciaInicial,
      //       diaVencimento: this.form.parcelas.boleto.diaVencimento
      //     },
      //     pix: {
      //       ativo: this.form.parcelas.pix.ativo ? 1 : 0,
      //       competenciaInicial: this.form.parcelas.pix.competenciaInicial,
      //       diaVencimento: this.form.parcelas.pix.diaVencimento
      //     }
      //   }
      // }

      const payload = { ...this.form }

      const isEdicao = this.formaParaEditar && this.formaParaEditar.forma?.idNegocieJaFormaPagamento

      if (isEdicao) {
        const id = this.formaParaEditar.forma.idNegocieJaFormaPagamento

        negociejaService.updatePagamentos(id, payload)
          .then(() => this.close())
          .catch(err => {
            console.error('Erro ao atualizar forma de pagamento:', err)
          })
      } else {
        negociejaService.createPagamentos(payload)
          .then(() => this.close())
          .catch(err => {
            console.error('Erro ao criar forma de pagamento:', err)
          })
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.descontos{
  padding-top: -1px;
  padding: 2rem;
}


.page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: $border-component;
  padding: $mg_small;
  h3 {
    color: $vermelho;
    margin: 0;
    // line-height: 1;
  }
}

.modal {
    padding: 0 !important;
}

.modal-content-wrapper {
  margin-top: 2rem;
  margin-bottom: 2rem;
  background: $branco;
  border-radius: $border-radius;
  border: $border-component;
  max-height: auto;
  display: flex;
  flex-direction: column;
}

footer {
  border-top: $border-component;
  padding: $mg_small;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: $branco;
  border-bottom-left-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
}

.tabs-panel {
  margin: 0 !important;
  .tabs-navs {
    margin: 0px !important;
    padding: 0 !important;
    display: flex;
    padding-bottom: $mg_small;
  }
  .tabs-nav {
    gap: 0px !important;
    border: 1px solid $border-component;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-radius: $border-radius-small;
    font-size: $font-size-small;
    color: $color-text;
    background: $color-secondary;
    cursor: pointer;
    text-decoration: none;
    &.active {
      border-color: $vermelho;
      // background: $vermelho;
      // color: $branco;
    }
    &:hover:not(.active) {
      border-color: $color-primary;
      color: $color-primary;
    }
  }
}

.method-card {
  margin: 0 !important;
  border-top: $border-component;
  // border-radius: $border-radius-small;
  margin-bottom: $mg;

  &:first-of-type {
    border-top: 0 !important
  }
  .method-header {
    display: flex;
    align-items: center;
    padding: $mg_mini $hmg_small;
    border-top: -1px ;
    h5 { margin: 0; }
  }
  .method-fields { padding: $mg_small $hmg_small; }
}
</style>
